import { useEffect, useState } from "react";

export const useEditorZoomControls = ({
  canvasDimension,
  setCanvasDimension,
  setCanvasUpdated,
}) => {
  const [canvasScrollToggle, setCanvasScrollToggle] = useState({
    height: canvasDimension.height,
    width: canvasDimension.width,
  });

  useEffect(() => {
    setCanvasScrollToggle({
      height: canvasDimension.height,
      width: canvasDimension.width,
    });
  }, [canvasDimension.height, canvasDimension.width]);

  const handleZoomIn = () => {
    let canvasHeight =
      (canvasDimension.height / 100) * (canvasDimension.zoomValue + 10);
    let canvasWidth =
      (canvasDimension.width / 100) * (canvasDimension.zoomValue + 10);
    setCanvasScrollToggle({ height: canvasHeight, width: canvasWidth });

    if (canvasDimension.zoomValue <= 390) {
      setCanvasDimension({
        ...canvasDimension,
        scale: canvasDimension.scale + 0.1,
        zoomValue: canvasDimension.zoomValue + 10,
      });
      setCanvasUpdated(true);
    }
  };

  const handleZoomOut = () => {
    let canvasHeight =
      (canvasDimension.height / 100) * (canvasDimension.zoomValue - 10);
    let canvasWidth =
      (canvasDimension.width / 100) * (canvasDimension.zoomValue - 10);
    setCanvasScrollToggle({ height: canvasHeight, width: canvasWidth });

    if (canvasDimension.zoomValue > 30) {
      setCanvasDimension({
        ...canvasDimension,
        scale: canvasDimension.scale - 0.1,
        zoomValue: canvasDimension.zoomValue - 10,
      });
      setCanvasUpdated(true);
    }
  };

  return {
    canvasScrollToggle,
    handleZoomIn,
    handleZoomOut,
  };
};
